import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../statics/LOGO.png';
import isoLogo from '../../statics/ISOlogo.png';
import './HomePage.css';

function HomePage() {
  const navigate = useNavigate();
  const [legacyBrowser, setLegacyBrowser] = useState(false);
  const [showLogo, setShowLogo] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("debug") === "legacy") {
      setLegacyBrowser(true);
      return;
    }
    if (!window.fetch || !window.Promise) {
      setLegacyBrowser(true);
    } else {
      setShowLogo(true);
      const timer = setTimeout(() => {
        navigate('/language-selection');
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [navigate]);

  // ← VERSIÓN MEJORADA: bloquea scroll pero permite pull-to-refresh en móviles
  useEffect(() => {
    if (legacyBrowser) {
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;   // guarda la posición actual
      document.body.style.width = '100%';
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);  // restaura la posición
    }
  }, [legacyBrowser]);

  return (
    <div className="home-page flex justify-center items-center min-h-screen">

      {legacyBrowser && (
        <div className="legacy-browser-overlay">
          <div className="iso-logo-container">
            <img src={isoLogo} alt="ISO Logo" className="iso-logo" />
          </div>

          <h2>Hola, sea bienvenid@</h2>
          <p>
            Puede que algunas animaciones no aparezcan en tu navegador ya que es un poco antiguo,
            pero podrás usar el sitio sin inconvenientes.<br />
            Presiona el botón para continuar.
          </p>

          <button
            className="continue-button"
            onClick={() => {
              setLegacyBrowser(false);
              setShowLogo(true);
              setTimeout(() => navigate('/language-selection'), 2000);
            }}
          >
            Continuar
          </button>
        </div>
      )}

      {!legacyBrowser && showLogo && (
        <img src={logo} alt="Logo" className="w-1/2 max-w-xs fadeIn mt-[-20vh]" />
      )}
    </div>
  );
}

export default HomePage;